// Order matches antd 6's font-family stack (Segoe UI before Roboto). The
// project's <body> stack puts Roboto first, but actual rendering happens
// inside antd cssinjs which uses this order, so canvas measurements must
// match what the browser will actually pick (Segoe UI on Windows, Roboto on
// Linux, system fonts on macOS).
export const XM_FONT_FAMILY = '12px -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif';
// export const XM_FONT_FAMILY = '12px -apple-system,BlinkMacSystemFont,Roboto,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif'

export const measureTextWidth = (text: string, font: string): number => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return 0;

  ctx.font = font;
  return Math.max(
    ...text.split(/\r?\n/).map(line => ctx.measureText(line).width)
  );
};
